import React from 'react';
import { IndustryBottleneckSection } from '../../data/industryData';
import '../../styles/IndustryBottlenecks.css';

interface IndustryBottlenecksProps {
  sections: IndustryBottleneckSection[];
}

// Modern SVG icons for categories
const getCategoryIcon = (icon: string) => {
  const icons: Record<string, React.ReactNode> = {
    "☁️": (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 19H9C6.79086 19 5 17.2091 5 15C5 12.7909 6.79086 11 9 11C9.12581 11 9.25033 11.0053 9.37302 11.0156C10.0205 9.21867 11.8426 8 14 8C16.7614 8 19 10.2386 19 13C19 13.7103 18.8364 14.3847 18.5452 15C19.8743 15.2681 20.9203 16.4175 20.9974 17.8207C21.0841 19.3964 19.7973 20.7246 18.222 20.725" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    "⚙️": (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M19.4 15C19.1277 15.6171 19.2583 16.3378 19.73 16.82L19.79 16.88C20.1656 17.2551 20.3766 17.7642 20.3766 18.295C20.3766 18.8258 20.1656 19.3349 19.79 19.71C19.425 20.0856 18.9158 20.2966 18.385 20.2966C17.8542 20.2966 17.3451 20.0856 16.98 19.71L16.92 19.65C16.4378 19.1783 15.7171 19.0477 15.1 19.32C14.4955 19.5791 14.1352 20.1794 14.14 20.83V21C14.14 22.1046 13.2446 23 12.14 23C11.0355 23 10.14 22.1046 10.14 21V20.91C10.1312 20.2443 9.74458 19.6374 9.11997 19.39C8.50286 19.1377 7.78216 19.2683 7.29997 19.74L7.23997 19.8C6.87492 20.1756 6.36577 20.3866 5.83497 20.3866C5.30418 20.3866 4.79503 20.1756 4.42997 19.8C4.05444 19.4349 3.84336 18.9258 3.84336 18.395C3.84336 17.8642 4.05444 17.3551 4.42997 16.99L4.48997 16.93C4.96167 16.4478 5.09231 15.7271 4.81997 15.11C4.56087 14.5055 3.96058 14.1452 3.30997 14.15H3.14997C2.59769 14.15 2.06857 13.9288 1.6817 13.5419C1.29483 13.155 1.07367 12.6259 1.07367 12.0736C1.07367 11.5213 1.29483 10.9922 1.6817 10.6053C2.06857 10.2184 2.59769 9.9972 3.14997 9.9972H3.23997C3.90569 10.0084 4.51262 9.62187 4.75997 9.00003" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    "🔐": (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 9V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 14V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17 21H7C5.89543 21 5 20.1046 5 19V11C5 9.89543 5.89543 9 7 9H17C18.1046 9 19 9.89543 19 11V19C19 20.1046 18.1046 21 17 21Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    "📊": (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 21H3V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21 9L15 15L9 9L3 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    "🔌": (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15 5H19V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 19H5V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  };

  return icons[icon] || <span>{icon}</span>;
};

// Decorative corner graphic for cards
const CornerGraphic = () => (
  <svg className="corner-graphic" width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M120 0H0V120L120 0Z" fill="currentColor" fillOpacity="0.04" />
    <path d="M120 0H40V40L120 0Z" fill="currentColor" fillOpacity="0.05" />
  </svg>
);

const IndustryBottlenecks: React.FC<IndustryBottlenecksProps> = ({ sections }) => {
  return (
    <div className="bottlenecks-section">
      <div className="bottlenecks-container">
        <div className="bottlenecks-header">
          <h2 className="bottlenecks-title">Industry Bottlenecks <span>We Solve</span></h2>
          <p className="bottlenecks-subtitle">
            Our expertise helps overcome these critical challenges that impact your operations
          </p>
        </div>
        
        {sections.map((section, sectionIndex) => (
          <div className="bottleneck-category" key={sectionIndex}>
            <div className="category-header">
              <div className="category-icon-container">
                <div className="category-icon">
                  {getCategoryIcon(section.icon)}
                </div>
              </div>
              <h3 className="category-title">{section.title}</h3>
            </div>
            
            <div className="bottleneck-cards-grid">
              {section.items.map((item, itemIndex) => (
                <div className="bottleneck-card" key={itemIndex}>
                  <div className="card-number">{itemIndex + 1}</div>
                  <div className="card-content">
                    <h4 className="card-title">{item.title}</h4>
                    <p className="card-description">{item.description}</p>
                    <CornerGraphic />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndustryBottlenecks; 